<div class="step-indicator-container" [class.compact]="compact()">
  <!-- Barra de progresso -->
  <div class="progress-bar-container">
    <mat-progress-bar 
      mode="determinate" 
      [value]="progressPercentage()"
      class="progress-bar">
    </mat-progress-bar>
  </div>

  <!-- Lista de etapas -->
  <div class="steps-list" [class.compact]="compact()">
    @for (step of steps(); track step.id; let i = $index) {
      <div 
        class="step-item {{ getStepClass(i) }}"
        [class.first]="i === 0"
        [class.last]="i === steps().length - 1"
        [class.compact]="compact()"
        (click)="onStepClick(i)"
        [attr.aria-current]="isStepActive(i) ? 'step' : null"
        [attr.aria-label]="'Etapa ' + (i + 1) + ' de ' + steps().length + ': ' + step.label"
        role="button"
        [tabindex]="isStepClickable(i) ? 0 : -1"
        (keydown.enter)="onStepClick(i)"
        (keydown.space)="onStepClick(i)">
        
        <!-- Ícone da etapa -->
        <div class="step-icon-container">
          <mat-icon class="step-icon">{{ getStepIcon(step, i) }}</mat-icon>
          <span class="step-number">{{ i + 1 }}</span>
        </div>

        <!-- Label da etapa (oculto em modo compacto) -->
        @if (!compact()) {
          <div class="step-label">
            <span class="step-title">{{ step.label }}</span>
            @if (isStepComplete(i)) {
              <span class="step-status">Completo</span>
            } @else if (isStepActive(i)) {
              <span class="step-status">Em andamento</span>
            }
          </div>
        }

        <!-- Linha conectora (não aparece na última etapa) -->
        @if (i < steps().length - 1 && !compact()) {
          <div class="step-connector"></div>
        }
      </div>
    }
  </div>

  <!-- Informação de progresso (mobile/compact) -->
  @if (compact()) {
    <div class="progress-info-mobile">
      <span class="progress-text">
        {{ steps()[currentStep()].label }} ({{ currentStep() + 1 }}/{{ steps().length }})
      </span>
    </div>
  }
</div>
